import { render, staticRenderFns } from "./ex-edit.vue?vue&type=template&id=64702d6c&scoped=true&"
import script from "./ex-edit.vue?vue&type=script&lang=js&"
export * from "./ex-edit.vue?vue&type=script&lang=js&"
import style0 from "./ex-edit.vue?vue&type=style&index=0&id=64702d6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64702d6c",
  null
  
)

export default component.exports